import { Routes, Route } from "react-router-dom";
import Main from "../pages/layouts/main";

import MainMenu from "../pages/layouts/main/main-menu";
import { Welcome } from "../pages/welcome";
import UnauthenticatedRoute from "./unauthenticated-route";
import { Login } from "../pages/login";
import ProtectedRoute from "./protected-routes";
import { Books } from "../pages/books/list/list-book";
import BookDetails from "../pages/books/details/details-book";
import NotFound from "../pages/errors/NotFound";
import { EditBook } from "../pages/books/edit/edit-book";
import { Account } from "../pages/user/account";
import { SearchGoogleBooks } from "../pages/google-books/search/search-book";
import GoogleBookDetails from "../pages/google-books/details/details-book";
import CatalogBookDetails from "../pages/catalog-books/details-book";
import RegisterUser from "../pages/register-account/register-account";
import { Share } from "../pages/books/share";
import BookReader from "../pages/books/reader/book-reader";
import PublishBook from "../pages/books/publish/publish-book";
import BookPurchasePage from "../pages/books/book-purchase-page/book-purchase-page";
import AuthorBalancePage from "../pages/books/author-balance-page/author-balance-page";
import AdminWithdrawalsPage from "../pages/books/admin-withdrawals-page/admin-withdrawals-page";
import AdminBooksPage from "../pages/admin/admin-books-page/admin/admin-books-page";
import MyCatalogs from "../pages/catalog-books/my-catalogs";
import ReadingDashboardPage from "../pages/dashboard/dashboard";
import BooksPublicPage from "../pages/books/public/books-public-page";

// ProtectedRouteUnauthenticated = usuários logados não podem acessar
// ProtectedRoute = usuários deslogados não podem acessar

const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Main />}>
                <Route path="/" element={<MainMenu />}>
                    <Route index element={<UnauthenticatedRoute><Welcome /></UnauthenticatedRoute>} />
                    <Route path="/livros" element={<ProtectedRoute><Books /></ProtectedRoute>} />
                    <Route path="/livros/publicados" element={<BooksPublicPage />} />
                    <Route path="/livros/criar" element={<ProtectedRoute><SearchGoogleBooks /></ProtectedRoute>} />
                    <Route path="/livros/publicar" element={<ProtectedRoute><PublishBook /></ProtectedRoute>} />
                    <Route path="/livros/editar/:uuid" element={<ProtectedRoute><EditBook /></ProtectedRoute>} />
                    <Route path="/livros/:uuid" element={<BookDetails />}/>
                    <Route path="/dashboard" element={<ReadingDashboardPage />}/>

                    <Route path="/catalogo" element={<MyCatalogs />}/>
                    <Route path="/catalogo/:id" element={<CatalogBookDetails />}/>
                    <Route path="/catalogo/:uuid/comprar"  element={<BookPurchasePage />} />

                    <Route path="/google-livros/:id" element={<ProtectedRoute><GoogleBookDetails /></ProtectedRoute>} />
                    <Route path="login" element={<UnauthenticatedRoute><Login /></UnauthenticatedRoute>} />
                    <Route path="cadastro" element={<UnauthenticatedRoute><RegisterUser /></UnauthenticatedRoute>} />
                    <Route path="/conta" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                    <Route path="/compartilhar" element={<><Share /></>} />
                    <Route path="/:username" element={<ProtectedRoute><Books /></ProtectedRoute>} />
                    <Route path="*" element={<NotFound title="404" />} />

                    
                    <Route path="/autor/ganhos" element={<AuthorBalancePage />} />
                    <Route path="/admin/saques" element={<AdminWithdrawalsPage />} /> {/* proteger com middleware admin */}
                    <Route path="/admin/livros" element={<AdminBooksPage />} /> {/* proteger com middleware admin */}
                </Route>

                <Route path="/livros/ler/:uuid" element={<BookReader />}/>

            </Route>
        </Routes>
    );
};

export default App;